import AuthMiddleware from '../middleware/auth';

const routes = [
  {
    path: '/ap/fbd/:formbuilder_code/:template_code/:formbuilder_details_id',
    name: 'ApplicationFormbuilderExecuteStep',
    component: () => import('@/components/formBuilders/formBuilderNewView.vue'),
    beforeEnter: AuthMiddleware.applicationUser,
    meta: { title: 'Execute Formbuilder Step' },
  },
  {
    path: '/ap/fbd/:formbuilder_details_id/:user_id',
    name: 'ApplicaionFormbuilderUserSubmittedDataList',
    component: () => import('@/components/formBuilders/FormbuilderUserSubmittedDataList.vue'),
    beforeEnter: AuthMiddleware.applicationUser,
    meta: { title: 'Submitted Form Data' },
  },
  {
    path: '/ap/fb/:formbuilder_code/:formbuilder_details_id/:formbuilder_data_id/status/completed',
    name: 'ApplicaionFormbuilderCompleted',
    component: () => import('@/components/formBuilders/formbuilderCompletedMessage.vue'),
    beforeEnter: AuthMiddleware.applicationUser,
    meta: { title: 'Form Submission Completed' },
  },
  {
    path: '/ap/fbdv/:formbuilder_code/data-list',
    name: 'ApplicaionFormbuilderDataList',
    component: () => import('@/components/formBuilders/formbuilderTemplateDataList.vue'),
    beforeEnter: AuthMiddleware.applicationUser,
    meta: { title: 'Form Data List' },
  },
  {
    path: '/ap',
    component: () => import('@/components/applicationUsers/applicationUsersDashboard.vue'),
    name: 'application-user',
    beforeEnter: AuthMiddleware.applicationUser,
    meta: { showChat: true },
    children: [
      {
        path: 'dashboard',
        name: 'application-user-dashboard',
        component: () => import('@/components/applicationUsers/CustomDashboard.vue'),
        meta: { title: 'Dashboard', showChat: true },
      },
      {
        path: 'page-dashboard/:dashboardId',
        name: 'application-user-page-dashboard',
        component: () => import('@/components/applicationUsers/PageCustomDashboard.vue'),
        meta: { title: 'Custom Page Dashboard', showChat: true },
      },
      {
        path: 'documents',
        name: 'application-user-documents',
        component: () => import('@/components/applicationUsers/applicationUsersDocuments.vue'),
        meta: { title: 'Documents', showChat: true },
      },
      {
        path: 'workflows',
        name: 'application-user-workflows',
        component: () => import('@/components/applicationUsers/applicationUsersWorkflows.vue'),
        meta: { title: 'Workflows', showChat: true },
      },
      {
        path: 'approvalforms',
        name: 'application-user-approvalforms',
        component: () => import('@/components/applicationUsers/applicationUsersApprovalForms.vue'),
        meta: { title: 'Approval Forms', showChat: true },
      },
      {
        path: 'fbd/:formbuilder_code',
        name: 'applicationFormBuilderUserData',
        component: () => import('@/views/formBuilders/FormBuilderUserData.vue'),
        meta: { title: 'Form Builder Data' },
      },
      {
        path: 'formbuilder',
        name: 'application-user-formbuilder',
        component: () => import('@/components/applicationUsers/applicationUsersFormbuilder.vue'),
        meta: { title: 'Form Builder' },
      },
      {
        path: 'profile',
        name: 'application-user-profile',
        component: () => import('@/components/applicationUsers/applicationUsersProfile.vue'),
        meta: { title: 'User Profile', showChat: true },
      },
      {
        path: 'entity/:entity_id/:menuId',
        name: 'application-user-entity',
        component: () => import('@/components/entity/ViewEntityData.vue'),
        meta: { title: 'Entity Data', showChat: true },
      },
      {
        path: 'external/entity/:entity_id/:menuId',
        name: 'application-user-external-entity',
        component: () => import('@/components/entity/externalView.vue'),
        meta: {
          title: 'Application User External View Entity Data',
          showChat: true,
        },
      },
      {
        path: 'entity-execute/:entity_id',
        name: 'ApEntityExecute',
        component: () => import('@/components/entity/EntityDetailedCardView.vue'),
        meta: { title: 'Execute Entity', showChat: true },
      },
      {
        path: 'entity-view/:entity_id',
        name: 'ApPreviewEntityData',
        component: () => import('@/components/entity/EntityDetailedCardView.vue'),
        meta: { title: 'Preview Entity Data', showChat: true },
      },
      {
        path: 'entity-views/view/:entity_view_id',
        name: 'ApplicationUserEntityViews',
        component: () => import('@/components/entity/EntityViews.vue'),
        meta: { title: 'Entity Views', showChat: true },
      },
      {
        path: '/ap/fb/:formbuilder_code/:formbuilder_data_id',
        name: 'ApplicationUserFormbuilderView',
        component: () => import('@/components/formBuilders/formbuilderView.vue'),
        children: [
          {
            path: '/ap/fb/view/:formbuilder_code/:template_code/:formbuilder_data_id',
            name: 'ApplicationUserFormbuilderViewStep',
            component: () => import('@/components/formBuilders/formbuilderViewStep.vue'),
            beforeEnter: AuthMiddleware.applicationUser,
            meta: { title: 'View Form Step' },
          },
        ],
      },
      {
        path: '/ap/fb/:formbuilder_code/:formbuilder_data_id',
        name: 'ApplicationUserFormbuilderEdit',
        component: () => import('@/components/formBuilders/formbuilderView.vue'),
        children: [
          {
            path: '/ap/fb/edit/:formbuilder_code/:template_code/:formbuilder_data_id',
            name: 'ApplicationUserFormbuilderEditStep',
            component: () => import('@/components/formBuilders/formbuilderViewStep.vue'),
            beforeEnter: AuthMiddleware.applicationUser,
            meta: { title: 'Edit Form Step' },
          },
        ],
      },
      {
        path: 'template/:template_id/menu/view',
        name: 'AppUserViewMenuTemplate',
        component: () => import('@/components/templates/ViewTemplate.vue'),
        meta: { title: 'View Template', showChat: true },
      },
      {
        path: 'forums',
        name: 'ApplicationUserAllForums',
        component: () => import('@/components/forums/AllForums.vue'),
        meta: { title: 'All Forums', showChat: true },
      },
      {
        path: 'create-forum',
        name: 'ApplicationUserCreateForum',
        component: () => import('@/components/forums/CreateForum.vue'),
        meta: { title: 'Create Forum', showChat: true },
      },
      {
        path: 'forum/:forum_id',
        name: 'ApplicationUserForumDetailedView',
        component: () => import('@/components/forums/ForumDetailedView.vue'),
        meta: { title: 'Forum Detail', showChat: true },
      },
      {
        path: 'integrations/:provider/:companyConfigId',
        name: 'KFMailUserIntegrationConfiguration',
        component: () => import('@/components/user-integrations/integartionConfig.vue'),
        meta: { title: 'KF-Mail', showChat: true },
      },
    ],
  },

  {
    path: '/ap/custom/dashboard/:entityId/:role_id?',
    name: 'entity-custom-dashboard-config',
    component: () => import('@/components/customDashboard/customDashboardConfig.vue'),
    beforeEnter: AuthMiddleware.user,
    meta: { title: 'Custom Dashboard', showChat: true },
  },
  {
    path: '/ap/expire',
    name: 'AppUserExpirePage',
    component: () => import('@/components/account/Expire.vue'),
    meta: { title: 'Plan Expired' },
  },
  {
    path: '/ap/welcome',
    name: 'ap-Welcome',
    component: () => import('@/views/contactLogin/welcome.vue'),
    meta: { title: 'Welcome' },
  },
  {
    path: '/ap/mfa',
    name: 'ap-mfa',
    component: () => import('@/views/contactLogin/mfa.vue'),
    meta: { title: 'MFA' },
  },
  {
    path: '/ap/signin',
    name: 'contact-login-page',
    component: () => import('@/views/contactLogin/loginPage.vue'),
    beforeEnter: AuthMiddleware.applicationGuest,
    meta: { title: 'Sign In' },
  },
  {
    path: '/ap/external/verify',
    name: 'external-contact-login-page',
    component: () => import('@/views/contactLogin/externalUserLogin.vue'),
    meta: { title: 'External Contact Sign In' },
  },
  {
    path: '/ap/forbidden',
    name: 'ap-forbidden',
    component: () => import('@/components/applicationUsers/applicationUsersForbidden.vue'),
    meta: { title: 'Access Forbidden' },
  },
  {
    path: '/ap/no-role-assigned',
    name: 'ap-no-role-assigned',
    component: () => import('@/components/applicationUsers/applicationUsersNoRole.vue'),
    meta: { title: 'No Role Assigned' },
  },
];

export default routes;
